import { useSurveyConfig } from 'app/core/survey-config';
import { Footer, InfoContainer } from 'app/shared/components';
import { useRemoveLoading } from 'app/shared/utils/removeLoading';
import privateImage from 'images/status/private.png';
import React from 'react';
import Form from './Form';

export default function Password() {
  const { wording } = useSurveyConfig();

  useRemoveLoading();

  return (
    <div>
      <InfoContainer
        image={privateImage}
        title={wording.common.exception.private.title}
        info={wording.common.exception.private.content}
      >
        <Form />
      </InfoContainer>
      <Footer />
    </div>
  );
}
